module.exports = __webpack_public_path__ + "img/tit.5c2d2d75.png";